<template>
	<div>
		<div>
			<el-form size="small" :model="ruleForm" :rules="rules" :hide-required-asterisk="false" ref="ruleForm" class="demo-ruleForm">
				<div class="add-box dis-flex">
					<div>
						<!-- <div class="title">基本信息</div> -->
						<el-form-item label="新编号" prop="new_number">
							<el-input :placeholder="rules.new_number[0].message" v-model="ruleForm.new_number"></el-input>
						</el-form-item>
						<el-form-item label="编号" prop="number">
							<el-input :placeholder="rules.number[0].message" v-model="ruleForm.number"></el-input>
						</el-form-item>
						<el-form-item label="方位">
							<el-radio v-model="ruleForm.direction" :label="k" v-for="(v, k) in rObj.direction">{{ v }}</el-radio>
						</el-form-item>
						<el-form-item label="投放形式">
							<el-radio v-model="ruleForm.scroll" :label="k" v-for="(v, k) in rObj.scroll">{{ v }}</el-radio>
						</el-form-item>
						<el-form-item label="亮灯情况">
							<el-radio v-model="ruleForm.light" :label="k" v-for="(v, k) in rObj.light">{{ v }}</el-radio>
						</el-form-item>
					<!-- 	<el-form-item label="品牌" prop="brand">
							<el-input :placeholder="rules.brand[0].message" v-model="ruleForm.brand"></el-input>
						</el-form-item> -->
						<el-form-item label="尺寸大小" prop="size">
							<el-input :placeholder="rules.size[0].message" v-model="ruleForm.size"></el-input>
						</el-form-item>
						<el-form-item label="流量" >
							<el-input :placeholder="rules.flow[0].message" v-model="ruleForm.flow"></el-input>
						</el-form-item>
						<el-form-item label="价格" prop="price">
							<el-input :placeholder="rules.price[0].message" v-model="ruleForm.price"></el-input>
						</el-form-item>
						<el-form-item label="制作费" prop="make_price">
							<el-input :placeholder="rules.make_price[0].message" v-model="ruleForm.make_price"></el-input>
						</el-form-item>
						<el-form-item label="标签">
							<el-input :placeholder="rules.tag[0].message" v-model="ruleForm.tag"></el-input>
						</el-form-item>
						<el-form-item label="灯箱规格" prop="category">
							<el-select style="width: 100%" v-model="ruleForm.category" placeholder="灯箱规格">
								<el-option :value="k" :label="v" v-for="(v,k) in rObj.category" :key="k">{{v}}</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="分布区域" >
							<el-input readonly @focus="showMap" suffix-icon="el-icon-map-location" :placeholder="rules.district[0].message" v-model="ruleForm.district"></el-input>
						</el-form-item>
						<el-form-item label="地址" prop="address"><el-input :placeholder="rules.address[0].message" v-model="ruleForm.address"></el-input></el-form-item>
						<el-form-item label="路段" prop="street"><el-input :placeholder="rules.street[0].message" v-model="ruleForm.street"></el-input></el-form-item>
						<el-form-item label="站名" prop="name"><el-input :placeholder="rules.name[0].message" v-model="ruleForm.name"></el-input></el-form-item>
						<el-form-item label="坐标" prop="zuobiao"><el-input readonly :placeholder="rules.zuobiao[0].message" v-model="ruleForm.zuobiao"></el-input></el-form-item>
					</div>
					<div style="margin-left: 50px">
						<!-- <div class="title">合作信息</div> -->
						<el-form-item label="仓库">
							<el-radio v-model="ruleForm.warehouse" :label="k" v-for="(v, k) in rObj.warehouse" :key="k">{{ v }}</el-radio>
						</el-form-item>
						<el-form-item label="级别">
							<el-radio v-model="ruleForm.grade" :label="k" v-for="(v, k) in rObj.grade">{{ v }}</el-radio>
						</el-form-item>
						<el-form-item label="拍照人员" >
							<el-select style="width: 100%" v-model="ruleForm.photographer" :placeholder="rules.photographer[0].message">
								<el-option :value="v.id" :label="v.name" v-for="(v,k) in rObj.user" :key="k">{{v.name}}</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="挂画人" >
							<el-select style="width: 100%" v-model="ruleForm.hang" :placeholder="rules.hang[0].message">
								<el-option :value="v.id" :label="v.name" v-for="(v,k) in rObj.user" :key="k">{{v.name}}</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="周边">
							<el-select size="small" v-model="value" placeholder="请选择">
							  <el-option
							   v-for="(v,k) in options"
							  :key="k"
							   name="name"
							  :label="v.name"
							  :value="v.id"
							    disabled
							    class="txt-btn"
							    style="
							      cursor: pointer !important;
							      overflow: visible !important;
							      height: auto !important;
							      width: 230px !important;
							      display: flex !important;
							      flex-wrap: wrap !important;
							      padding-bottom:12px;">
							      <div style="color:#606266">{{v.name}}</div>
												<div style="color:#606266" 
												:style="[tagStyle,allTag,v.check == true?selTag:noselTag]"
												@click="tagAll(v,k)">全选</div>
							      <div
							        style="
							          width: 230px;
							          display: flex !important;
							          flex-wrap: wrap !important;">
							        <span
							          :style="[tagStyle,item.check == true?selTag:noselTag]"
							          ref="zbTag"
							          @click="onSelectTag(item,k,key)"
							          v-for="(item,key) in v.children"
							          :key="key"
							          >{{item.name}}</span>
							      </div>
							  </el-option>
							</el-select>
						</el-form-item>
						<!-- <el-form-item label="周边介绍" prop="industry">
              <el-input
                :placeholder="rules.industry[0].message"
                v-model="ruleForm.industry"
              ></el-input>
            </el-form-item> -->
						<el-form-item label="备注" ><el-input :placeholder="rules.remark[0].message" v-model="ruleForm.remark"></el-input></el-form-item>
						<el-form-item label="上传图片">
							<div style="width: 80%;">
								<el-upload
								  :on-success="onSuccess"
								  :before-upload="beforeUpload"
								  :action="action"
								  :limit="6"
								  :multiple="true"
								  :file-list="fileList"
								  list-type="picture-card"
								  :on-preview="handlePictureCardPreview"
								  :on-remove="handleRemove">
								  <i class="el-icon-plus"></i>
								</el-upload>
							</div>
						</el-form-item>
					</div>
				</div>
			</el-form>
		</div>
		<div class="row1">
			<div>
				<el-button v-if="isEdit" @click="submitForm('ruleForm','editAdvertise')" class="row-btn add" type="primary" size="small">修改</el-button>
				<el-button v-else @click="submitForm('ruleForm','addAdvertise')" class="row-btn add" type="primary" size="small">提交</el-button>
				<el-button @click="back" class="row-btn add back" type="primary" size="small">返回</el-button>
			</div>
		</div>
		<el-dialog :visible.sync="diaVisible">
		  <img width="100%" :src="dialogImageUrl" alt="">
		</el-dialog>
		<map-dialog :mapPosition="position" @onData="onMapData" ref="dialogVisible"></map-dialog>
	</div>
</template>

<script>
import * as imageConversion from 'image-conversion'
import mapDialog from '../../components/dialog/map/mapDialog.vue';
export default {
	components: {
		mapDialog
	},
	data() {
		return {
			nowPage:'',
			addOrDel:false,//是否删减了图片
			fileList:[],
			action:'',//上传图片地址
			headers:{},//上传图片头部参数
			 dialogImageUrl: '',
			diaVisible: false,
			tagStyle:{
			  marginTop: '7px',
			  lineHeight: '21px',
			  display: 'inline-block',
			  padding: '0 10px !important',
			  borderRadius: '2px',
			  marginRight: '10px',
			},
			allTag:{
					  lineHeight: '22px',
					  height:'22px',
					  marginTop: '5px',
					  marginLeft:'10px'
			},
			selTag:{
			  color:'#409EFF',
			  border: '1px solid #409EFF',
			},
			noselTag:{
			  color:'#C0C4CC',
			  border: '1px solid #C0C4CC',
			},
			options:[],
			value:'',
			tagArr:[],
			isEdit:0,
			rObj:{
				direction:[],
				grade:[],
				scroll:[],
				warehouse:[],
				light:[],
				category:[],
				user:[]
			},
			position: {},
			hangId:0,
			photographerId:0,
			ruleForm: {
				number: '',//编号
				street: '',//路段
				name: '',//广告位名称/站点
				address: '',//地址
				flagItem: '',
				photographer: '',//拍照人ID
				hang: '',//挂画人ID
				// department: '',
				// industry: '',
				remark: '',//备注
				category:0,//分类标识，大牌、小牌
				scroll: 0,//是否滚动 1滚,0不滚
				light: 0,//是否亮灯 1亮,0不亮
				grade:0,//等级标识
				warehouse:0,//仓库标识
				direction:0,//方向
				price:'',//价格
				make_price:'',//制作费
				tag:'',//标签
				size:'',//尺寸大小
				flow:'',//流量
				longitude:'',//经度
				latitude:'',//纬度
				periphery:[],//周边ID合集[,1,3,4,6]
				zuobiao:'',
				images:[]
			},
			rules: {
				flow: [{ required: true, message: '请输入流量', trigger: ['change', 'blur'] }],
				price: [{ required: true, message: '请输入价格', trigger: ['change', 'blur'] }],
				make_price: [{ required: true, message: '请输入制作费', trigger: ['change', 'blur'] }],
				tag: [{ required: true, message: '请输入标签', trigger: ['change', 'blur'] }],
				size: [{ required: true, message: '请输入尺寸大小', trigger: ['change', 'blur'] }],
				number: [{ required: true, message: '请输入编号', trigger: ['change', 'blur'] }],
				new_number: [{ required: true, message: '请输入新编号', trigger: ['change', 'blur'] }],
				brand: [{ required: true, message: '请输入品牌', trigger: ['change', 'blur'] }],
				category: [{ required: true, message: '请选择灯箱规格', trigger: ['change', 'blur'] }],
				street: [{ required: true, message: '请输入路段', trigger: ['change', 'blur'] }],
				name: [{ required: true, message: '请输入站名', trigger: ['change', 'blur'] }],
				zuobiao: [{ required: true, message: '请输入坐标', trigger: ['change', 'blur'] }],
				address: [{ required: true, message: '请输入地址', trigger: ['change', 'blur'] }],
				district: [{ required: true, message: '请选择分布区域', trigger: ['change', 'blur'] }],
				photographer: [{ required: true, message: '请输入拍照人员', trigger: ['change', 'blur'] }],
				hang: [{ required: true, message: '请输入挂画人员', trigger: ['change', 'blur'] }],
				department: [{ required: true, message: '请选择周边', trigger: ['change', 'blur'] }],
				industry: [{ required: true, message: '请输入周边介绍', trigger: ['change', 'blur'] }],
				remark: [{ required: true, message: '请输入备注', trigger: ['change', 'blur'] }]
			},
			radio: 1
		};
	},
	created() {
		// this.headers['Cookie'] = 'PHPSESSID='+ this.getCookie('PHPSESSID')
		// console.log(this.headers);
		this.action = this.$baseUrl + '/admin/ajax/upload?PHPSESSID='+this.getCookie('PHPSESSID')  
		let editObj = this.$route.query.obj;
		if(editObj){
			this.isEdit = 1;
			editObj = JSON.parse(editObj)
			this.nowPage = editObj.paramObjnowPage
			// console.log(editObj);
			editObj.images.forEach((it,ke)=>{
				if(it.id){
					this.fileList[ke] = {
						url:it.url,
						id:it.id
					}
				}
			})
			console.log(editObj);
			// this.hangId = editObj.hang.id
			// this.photographerId = editObj.photographer.id
			this.ruleForm = editObj
			this.ruleForm.scroll = editObj.scroll.value;
			this.ruleForm.light = editObj.light.value;
			this.ruleForm.grade = editObj.grade.value;
			this.ruleForm.warehouse = editObj.warehouse.value;
			this.ruleForm.direction = editObj.direction.value;
			this.ruleForm.category = editObj.category.value;
			this.ruleForm.hang = editObj.hang.id;
			this.ruleForm.photographer = editObj.photographer.id;
			this.ruleForm.zuobiao = editObj.longitude + ',' + editObj.latitude
			
			let aArr = ['create_time','update_time','delete_time']
			aArr.forEach((v,k)=>{
				delete this.ruleForm[v]
			})
			console.log(this.ruleForm);
		}else{
			this.isEdit = 0;
		}
		this.getConfig();
		this.getuser()
	},
	methods: {
		beforeUpload(file){
			return new Promise((resolve, reject) => {
			  	imageConversion.compress(file,0.8).then(res => { 
			  	  console.log(file);
			  	  resolve(res)
			  	})
			})
			// return new Promise((resolve, reject) => {
			// 	let isLt2M = file.size / 1024 / 1024 < 4 // 判定图片大小是否小于4MB
			// 	console.log(isLt2M);
			// 	if (isLt2M) {
			// 	   resolve(file)
			// 	}else{
			// 		// console.log(file) // 压缩到400KB,这里的400就是要压缩的大小,可自定义
			// 		imageConversion.compressAccurately(file, 400).then(res => { // console.log(res)
			// 		  console.log(file);
			// 		  resolve(res)
			// 		})
			// 	}
			// })
		},
		//上传图片回调
		onSuccess(response, file, fileList){
			this.addOrDel = true;
			this.ruleForm.images = []
			fileList.forEach((v,k)=>{
				if(v.id){
					this.ruleForm.images.push(v.id)
				}else{
					let response = v.response
					if(response.code == 1){
						this.ruleForm.images.push(response.data.id)
					}else{
						this.$message.error(res.msg)
					}
				}
			})
			console.log(this.ruleForm.images);
		},
		//移除图片
		handleRemove(file, fileList) {
			this.addOrDel = true;
			console.log(file, fileList);
			this.ruleForm.images = []
			fileList.forEach((v,k)=>{
				if(v.id){
					this.ruleForm.images.push(v.id)
				}else{
					let response = v.response
					if(response.code == 1){
						this.ruleForm.images.push(response.data.id)
					}else{
						this.$message.error(res.msg)
					}
				}
			})
			console.log('-------移除后-------');
			console.log(this.ruleForm.images);
		  },
		  handlePictureCardPreview(file) {
			this.dialogImageUrl = file.url;
			this.diaVisible = true;
		  },
		//详情
		detailAdvertise(id){
			this.$api2.detailAdvertise({id:id}).then((res)=>{
				if(res.code == 1){
					this.ruleForm = res.data			}
			})
		},
		//点击全选
		tagAll(v,k){
			this.tagArr = []
			this.options[k].children.forEach((item,index)=>{
				this.options[k].children[index].check = v.check == true?false:true;
			})
			this.options[k].check = v.check == true?false:true;
			this.options.forEach((vva,kke)=>{
				this.options[kke].children.forEach((vv,kk)=>{
					if(vv.check){
						this.tagArr.push(vv.name) 
					}
				})
				if(vva.check && !this.options[kke].children.length){
					this.tagArr.push(this.options[kke].name)
				}
			})
			this.value = this.tagArr
		},
		// 点击周边下拉框中的标签
		onSelectTag(item,k,key) {
			this.tagArr = []
			this.options[k].children[key].check = item.check == true?false:true;
			if(item.check == false){
				this.options[k].check = false
			}
			let i = 0;
			this.options[k].children.forEach((va,ke)=>{
				if(va.check){
					i += 1;
				}
			})
			// 本项标签全选时情况
			if(i == this.options[k].children.length){
				this.options[k].check = true;//全选变颜色
					// console.log(this.options[k]);
			}
			this.options.forEach((vva,kke)=>{
				if(vva.check){
					this.tagArr.push(vva.name) 
				}
				this.options[kke].children.forEach((vv,kk)=>{
					if(vv.check){
						// console.log(vv.check);
						this.tagArr.push(vv.name) 
					}
				})
			})
			this.value = this.tagArr
		},
		//配置信息
		getConfig() {
			this.$api2.getConfig().then(res => {
				if (res.code == 1) {
					this.rObj.scroll = res.data.enum.scroll;
					this.rObj.light = res.data.enum.light;
					this.rObj.grade = res.data.enum.grade;
					this.rObj.warehouse = res.data.enum.warehouse;
					this.rObj.direction = res.data.enum.direction;
					this.rObj.category = res.data.enum.category;
					this.options = res.data.enum.periphery
					let strArr = []
					console.log(this.ruleForm.periphery);
					this.ruleForm.periphery.forEach((v,k)=>{
						if(!v.children){
							strArr.push(v.name)
						}else{
							v.children.forEach((citem,cindex)=>{
								strArr.push(citem.name)	
							})
						}
					})	
					res.data.enum.periphery.forEach((v,k)=>{
						this.ruleForm.periphery.forEach((item,index)=>{
							if(item.id == v.id){
								if(item.check && !item.children){
									this.options[k].check = true;
								}
								v.children.forEach((v2,k2)=>{
									item.children.forEach((item2,index2)=>{
										if(v2.id == item2.id){
											this.options[k].children[k2].check = true;
										}
									})
								})
							}
						})
					})
					
					console.log(this.options);
					this.options.forEach((v,k)=>{
						if(v.check || v.children.length){
							let i = 0;
							v.children.forEach((vv,kk)=>{
								if(vv.check){
									i++;
								}
							})
							console.log(i);
							if(i == v.children.length && this.ruleForm.periphery.length){
								this.options[k].check = true;
							}
						}
					})
					this.value = strArr.toString()
				}
			});
		},
		onMapData(e) {
			this.ruleForm.province = e.province;
			this.ruleForm.city = e.city;
			this.ruleForm.district = e.area;
			this.ruleForm.longitude = e.longitude;
			this.ruleForm.latitude = e.latitude;
			this.ruleForm.zuobiao = e.zuobiao;
			this.ruleForm.street = e.luduan;
			this.ruleForm.address = e.address;
			this.ruleForm.flagItem = e.area;
			this.ruleForm.name = e.station;
			console.log(e);
		},
		// 点击分布区域，弹出弹框
		showMap() {
			let that = this;
			AMap.plugin('AMap.Geolocation', function() {
				var geolocation = new AMap.Geolocation({
					// 是否使用高精度定位，默认：true
					enableHighAccuracy: false,
					// 设置定位超时时间，默认：无穷大
					timeout: 10000,
					// 定位按钮的停靠位置的偏移量，默认：Pixel(10, 20)
					buttonOffset: new AMap.Pixel(10, 20),
					//  定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
					zoomToAccuracy: true,
					//  定位按钮的排放位置,  RB表示右下
					buttonPosition: 'RB'
				});
				geolocation.getCurrentPosition();
				// AMap.event.addListener(geolocation, 'complete', onComplete);
				// AMap.event.addListener(geolocation, 'error', onError);
				that.$refs.dialogVisible.dialogVisible = true;
				function onComplete(data) {
					console.log(data);
					// data是具体的定位信息
					data.lntlat = [data.position.lng, data.position.lat];
					// console.log(data);
					that.position = data;
					that.$refs.dialogVisible.dialogVisible = true;
				}
				function onError(data) {
					// 定位出错
					that.$message({
						message: '定位出错！',
						type: 'warning'
					});
				}
			});
			// this.$refs.dialogVisible.dialogVisible = true;
		},
		// 返回
		back() {
			// this.$router.go(-1);
			this.$router.push({ path: "/siteList",query:{nowPage:this.nowPage} });
		},
		//   提交按钮
		submitForm(formName,api) {
			// console.log(this.fileList);
			// console.log(this.ruleForm.images);
			this.$refs[formName].validate(valid => {
				if (valid) {
					// if(!this.ruleForm.images.length) return this.$message.error('请上传图片')
					if(!this.addOrDel){
						let imgArr = this.ruleForm.images
						this.ruleForm.images = []
						imgArr.forEach((valv,keyk)=>{
							this.ruleForm.images.push(valv.id)
						})
					}
					console.log('提交');
					this.ruleForm.images = this.ruleForm.images.toString()
					this.ruleForm.periphery = []
					this.options.forEach((v,k)=>{
						if(v.check){
							this.ruleForm.periphery.push(v.id)
						}
						this.options[k].children.forEach((val,key)=>{
							if(val.check){
								this.ruleForm.periphery.push(v.id)
								this.ruleForm.periphery.push(val.id)
							}
						})
					})
					const setArr = new Set(this.ruleForm.periphery); //去除重复值
					this.ruleForm.periphery = [...setArr]
					this.ruleForm.periphery = ','+ this.ruleForm.periphery.toString() + ','
					// if(!(Number(this.ruleForm.hang) >= 0)){
					// 	this.ruleForm.hang = this.hangId
					// }
					// if(!(Number(this.ruleForm.photographer) >= 0)){
					// 	this.ruleForm.photographer = this.photographerId
					// }
					this.$api2[api](this.ruleForm).then((res)=>{
						if(res.code == 1){
							this.$message.success(res.msg)
							setTimeout(()=>{
								this.$router.push({ path: "/siteList",query:{nowPage:this.nowPage} });
							},1.2e3)
						}else{
							this.$message.error(res.msg)
						}
					})
					console.log(this.ruleForm);
				} else {
					this.$message.error('请输入或选择必填项！');
					return false;
				}
			});
		},
		// 挂画人，拍照人
		getuser(){
			this.$api.usrList().then((res)=>{
				if(res.code == 1){
					this.rObj.user = res.data
				}else{
					this.$message.error(res.msg)
				}
			})
		},
		// 获取cookie
		getCookie(name) {
		 var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
		 if (arr = document.cookie.match(reg))
		  return (arr[2]);
		 else
		  return null;
		},
	}
};
</script>

<style lang="scss" scoped>
.row1 {
	padding-top: 20px;
	.add {
		padding: 12px 35px;
	}
	.back {
		background-color: #fff;
		color: gray;
		border: 1px solid #dcdfe6;
	}
}
.add-box /deep/ {
	.title {
		font-weight: bold;
		margin-bottom: 10px;
	}
	.el-input {
		width: 300px;
	}
	.el-form-item {
		padding-left: 0 !important;
	}
	.el-form-item__content {
		margin-left: 75px !important;
	}
	.el-form-item__label {
		height: 30px;
		width: 60px !important;
		text-align: justify;
	}
	.el-form-item__label:after {
		display: inline-block;
		content: '';
		padding-left: 100%;
	}
	.el-form-item {
		padding: 10px 30px;
	}
}
/* 去除验证的红色星号 */
.dis-flex /deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
	content: ' ';
	width: 0px;
	margin-right: 0px;
}
</style>
>
